var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "container-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" Type ")]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "split"
  }, [_vm._m(0), _c('div', {
    staticClass: "media-container",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px",
      "border": "1px solid #ccc",
      "padding": "3px",
      "display": "inline-block"
    }
  }, [_vm.body.imageUrl ? _c('div', {
    staticClass: "go-left pointer",
    staticStyle: {
      "display": "flex"
    },
    on: {
      "click": function ($event) {
        return _vm.imagePreview(_vm.body.imageUrl);
      }
    }
  }, [_c('img', {
    staticClass: "attachment mr6",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.getFullImage(_vm.body.imageUrl),
      "height": "35px",
      "width": "35px"
    }
  }), _c('div', {
    staticClass: "p-file-name"
  }, [_c('span', {
    staticClass: "font12 p-file-name mr6",
    staticStyle: {
      "line-height": "35px"
    }
  }, [_vm._v(_vm._s(_vm.getNameFromUrl(_vm.body.imageUrl)))])])]) : _c('div', {
    staticClass: "go-left",
    staticStyle: {
      "width": "calc(100% - 112px)"
    }
  }, [_c('img', {
    staticClass: "attachment mh6",
    attrs: {
      "src": require('@/assets/icons/Vectorpaperclip.png'),
      "width": "8px"
    }
  }), _c('span', {
    staticClass: "font10",
    staticStyle: {
      "line-height": "35px"
    }
  }, [_vm._v("No file selected( 500 x 750px )")])]), _c('label', {
    staticClass: "btn btn-secondary btn-sm go-right mt2 mr2",
    attrs: {
      "id": "image"
    },
    on: {
      "click": _vm.chooseImage
    }
  }, [_vm._v(" Choose file ")])])])]), _c('div', {
    staticClass: "split"
  }, [_vm._m(1), _c('div', [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.name,
      expression: "body.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Input name..."
    },
    domProps: {
      "value": _vm.body.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "name", $event.target.value);
      }
    }
  })])])]), _c('div', {
    staticClass: "split"
  }, [_vm._m(2), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.type,
      expression: "body.type"
    }],
    staticClass: "input-container",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "service"
    }
  }, [_vm._v("Service")]), _c('option', {
    attrs: {
      "value": "training"
    }
  }, [_vm._v("Training")])])]), _vm.body.type === 'training' ? _c('div', {
    staticClass: "split"
  }, [_vm._m(3), _vm.data.categories && _vm.data.categories.length > 0 ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.parentId,
      expression: "body.parentId"
    }],
    staticClass: "input-container",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "parentId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "value": ""
    }
  }, [_vm._v("Main Course")]), _vm._l(_vm.data.categories, function (category, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": category.id
      }
    }, [_vm._v(" " + _vm._s(category.name))]);
  })], 2) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "split"
  }, [_vm._m(4), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.subId,
      expression: "body.subId"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Input number..."
    },
    domProps: {
      "value": _vm.body.subId
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "subId", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "split"
  }, [_vm._m(5), _c('div', [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.shortDescription,
      expression: "body.shortDescription"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Input short description..."
    },
    domProps: {
      "value": _vm.body.shortDescription
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "shortDescription", $event.target.value);
      }
    }
  })])])]), _c('div', {
    staticClass: "split"
  }, [_vm._m(6), _c('vue-editor', {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "id": "editor",
      "editor-toolbar": _vm.customToolbar
    },
    model: {
      value: _vm.body.description,
      callback: function ($$v) {
        _vm.$set(_vm.body, "description", $$v);
      },
      expression: "body.description"
    }
  })], 1), _c('div', {
    staticClass: "split"
  }, [_vm._m(7), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.sortOrder,
      expression: "body.sortOrder"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Input number..."
    },
    domProps: {
      "value": _vm.body.sortOrder
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "sortOrder", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "split",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._m(8), _c('div', {
    staticClass: "select"
  }, [_c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.status,
      expression: "body.status"
    }],
    attrs: {
      "type": "radio",
      "id": "active",
      "value": "active"
    },
    domProps: {
      "checked": _vm._q(_vm.body.status, "active")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.body, "status", "active");
      }
    }
  }), _c('label', {
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Active")])]), _c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.status,
      expression: "body.status"
    }],
    attrs: {
      "type": "radio",
      "id": "inactive",
      "value": "inactive"
    },
    domProps: {
      "checked": _vm._q(_vm.body.status, "inactive")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.body, "status", "inactive");
      }
    }
  }), _c('label', {
    attrs: {
      "for": "inactive"
    }
  }, [_vm._v("Inactive")])])])])]), _c('div', {
    staticClass: "form-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-secondary mr8",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" Cancel ")]), !_vm.isCreating ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.submitCreateTicketType
    }
  }, [_vm._v(" Create ")]) : _c('button', {
    staticClass: "btn btn-info"
  }, [_vm._v("Loading...")])])])]), _vm.display.imagePreview ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal"
  }, [_c('img', {
    staticClass: "attachment mr6",
    attrs: {
      "src": _vm.getFullImage(_vm.display.url)
    }
  })])]) : _vm._e(), _vm.display.media ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal-md"
  }, [_c('Media', {
    attrs: {
      "type": "single",
      "method": _vm.closeModal,
      "folder": "ticketType"
    },
    on: {
      "existedMedia": _vm.existedMediaCallback
    }
  })], 1)]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Image :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "txt-danger",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Name :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "txt-danger",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Type:")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Training Course:")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("SubId :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Short description :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Desciption :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "txt-danger",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Sort Order :")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "txt-danger",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Status :")])]);

}]

export { render, staticRenderFns }